import React from "react";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Routes from "./Routes";

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}>
      <Routes />
    </GoogleReCaptchaProvider>
  );
}

export default App;
